import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchUserDetailsByNetId } from '../services/api';
import { useUser } from '../context/UserContext';

function UserDetails() {
    const { netId } = useParams();
    const [user, setUser] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const { user: loggedInUser } = useUser();

    useEffect(() => {
        fetchUserDetailsByNetId(netId)
            .then(setUser)
            .catch(error => {
                console.error('Failed to fetch user details:', error);
                setError('Failed to fetch user details');
            });
    }, [netId]);

    if (error) {
        return <div className="alert alert-danger" role="alert">{error}</div>;
    }

    if (!user) {
        return <div>Loading...</div>;
    }

    const handleEdit = () => {
        navigate(`/user/${netId}/edit`);
    };

    const isOwner = loggedInUser && (loggedInUser.accountLevel == 2 || loggedInUser.netId == user?.netId);
    //console.log(isOwner);

    return (
        <div className="container mt-3">
            <div className="page-header">
                <h1 className="gradient-under">Profile: {user.netId}@uw.edu</h1>
            </div>
            <h3 className='h4'>{user.firstName} {user.lastName}</h3>
            <div>Department: <b>{user.department}</b></div>
            <div>Box Number: <b>{user.boxNumber}</b></div>
            <div>Phone: <b>{user.phone || 'None'}</b></div>
            { isOwner  && 
                <button className="btn btn-primary mt-3" onClick={handleEdit}><img src={'/img/pencil-icon.svg'} alt="transfer-icon" className='me-2 icon-1-rem'/>Edit User Details</button>
            }            
        </div>
    );
}

export default UserDetails;
